module.exports = "/images/bg_3b76c9.png";